export default "__VITE_ASSET__DWe0hEBV__"